import { Badge as NovaBadge } from '@fme-nova/components'
import { Badge as MuiBadge, BadgeProps } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'

export const Badge = createComponentWrapperWithRef<BadgeProps>(
  {
    mui: MuiBadge,
    nova: NovaBadge,
  },
  'Badge',
)
